<mat-card appearance="outlined">


    <mat-card-content class="mt-4">
        @let vm = viewState();

        <div class="flex flex-col gap-4">
            <div class="border-outline grid gap-3 rounded border border-solid p-4 md:grid-cols-3">
                <div>
                    <div class="text-sm font-medium">Account credit</div>
                    <div class="text-lg">{{vm.currentAccountCreditLabel}}</div>
                </div>

                <div>
                    <div class="text-sm font-medium">PAYG budget</div>
                    <div class="text-lg">{{vm.paygBudgetLabel}}</div>
                </div>

                <div>
                    <div class="text-sm font-medium">PAYG used</div>
                    <div class="text-lg">{{vm.paygConsumedLabel ?? 'Not loaded'}}</div>
                </div>
            </div>

            <form class="border-outline flex flex-col gap-4 rounded border border-solid p-4"
                  (submit)="submitCreditAdjustment($event)">
                <div class="flex items-center justify-between gap-4">
                    <h2 class="m-0 text-lg">Add account credit</h2>
                    @if (vm.showBalanceLoading) {
                    <span class="text-sm">Refreshing...</span>
                    }
                </div>

                <div class="grid gap-4 md:grid-cols-[minmax(0,18rem)_minmax(0,1fr)_auto] md:items-start">
                    <mat-form-field class="w-full">
                        <mat-label>Credit amount</mat-label>
                        <input matInput
                               type="number"
                               step="0.01"
                               placeholder="credit amount in GBP"
                               [formField]="creditAdjustmentForm.creditGbp">
                        <mat-hint>GBP</mat-hint>

                        @for (error of creditAdjustmentForm.creditGbp().errors(); track error.kind) {
                        <mat-error>
                            {{error.message}}
                        </mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Adjustment reason</mat-label>
                        <input matInput
                               placeholder="why is this credit being added?"
                               [formField]="creditAdjustmentForm.description">

                        @for (error of creditAdjustmentForm.description().errors(); track error.kind) {
                        <mat-error>
                            {{error.message}}
                        </mat-error>
                        }
                    </mat-form-field>

                    <button matButton="filled"
                            type="submit"
                            [disabled]="!creditAdjustmentForm().valid() || creditAdjustmentForm().submitting()"
                            aria-label="Add Stripe account credit">
                        <mat-icon>add_card</mat-icon>
                        {{creditAdjustmentForm().submitting() ? 'Saving...' : 'Add Credit'}}
                    </button>
                </div>
            </form>

            <form class="border-outline flex flex-col gap-4 rounded border border-solid p-4"
                  (submit)="submitPaygBudgetLimit($event)">
                <h2 class="m-0 text-lg">Set PAYG budget</h2>

                <div class="flex flex-col gap-4 md:flex-row md:items-start">
                    <mat-form-field class="w-full md:w-72">
                        <mat-label>PAYG budget limit</mat-label>
                        <input matInput
                               type="number"
                               step="0.01"
                               placeholder="monthly limit in GBP"
                               [formField]="paygBudgetForm.limitGbp">
                        <mat-hint>GBP per month</mat-hint>

                        @for (error of paygBudgetForm.limitGbp().errors(); track error.kind) {
                        <mat-error>
                            {{error.message}}
                        </mat-error>
                        }
                    </mat-form-field>

                    <button matButton="filled"
                            type="submit"
                            [disabled]="!paygBudgetForm().valid() || paygBudgetForm().submitting()"
                            aria-label="Set PAYG budget limit">
                        <mat-icon>price_check</mat-icon>
                        {{paygBudgetForm().submitting() ? 'Saving...' : 'Set Limit'}}
                    </button>
                </div>
            </form>
        </div>
    </mat-card-content>
</mat-card>
